import React,{useState,useEffect} from "react"
import { useLocation as location2 } from "wouter";
import Confirm from "../components/Confirm";
import nl2br from "react-nl2br";
import Alert from "../components/Alert";
import post from "../post";
import cn from "classnames";
import Loading from "../components/Loading";
const toPesos=function(n){
    const options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    };
    return Number(n).toLocaleString('en', options);  
}


const Checkout=()=>{
    const [location, navigate] = location2();
    const user_id = localStorage.getItem('token');
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const currentOrder=JSON.parse(localStorage.getItem('currentOrder')) || {};
    const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });
    const [pInfo, setPInfo] = useState(null);
    const [checkedPayment, setCheckedPayment] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    if (!user_id) {
      navigate('/login');        
    }
    if(!cart || cart.length===0){
        navigate('/');
    }
    if(!currentOrder || !currentOrder.tipo){
        navigate('/tipoSelect');
    }
    const total=cart.reduce((sum, item) => sum + (parseFloat(item.precio)+parseFloat(+item.precio_extras ))* item.q, 0);
    useEffect(() => {
       const getPInfo=async () => {
          const pInfo = await post('getPInfo', {sucursal_id:currentOrder?.sucursal_id || null});
          if(!pInfo.result){
            setAlert({ isOpen: true, title: 'Error', message: pInfo.motive || 'Error de conexión. Intente nuevamente más tarde.',onClose:()=>navigate('/cart') }); 
          }else{
            setPInfo(pInfo.data);
          }
         }
        getPInfo();
      }, []);
    const handleCheckout=async()=>{
      setIsLoading(true);
        const orderPayload={
            cart,
            currentOrder:currentOrder,
            payment_method:checkedPayment
        };
        const res=await post('placeOrder',orderPayload);
        setIsLoading(false);
        if(!res.result){
            setAlert({ isOpen: true, title: 'Error', message: res.motive || 'Error de conexión. Intente nuevamente más tarde.' });
        }else{
            if(res.data.payment_method!='app'){
                setAlert({ isOpen: true, title: 'Orden recibida', message: res.data.tipo=='out'?'Su pedido ha sido realizado con éxito. Por favor, diríjase a la sucursal para recoger su pedido.':'Su pedido ha sido realizado con éxito. En breve un repartidor lo llevará al domicilio seleccionado.',onClose:()=>{
                  
                        localStorage.removeItem('cart');
                        localStorage.removeItem('currentOrder');
                        navigate('/');
                    }  });
                return;
            }else{//tipo pagar aquí, pedir stripe session
                setIsLoading(true);
                const sessionRes=await post('createCheckoutSession',{...orderPayload,order_id:res.data.id_ppedido});

                if(!sessionRes.result){
                    setIsLoading(false);
                    setAlert({ isOpen: true, title: 'Error', message: sessionRes.motive || 'Error de conexión. Intente nuevamente más tarde.' });
                    return;
                }else{
                    localStorage.currentOrder=JSON.stringify({...
                        currentOrder,order_id:res.data.id_ppedido});
                    window.location.href=sessionRes.data.url;
                }
            }
               
        }
    }
    return (<div id="webcrumbs">
            <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => {alert.onClose?alert.onClose():setAlert({ ...alert, isOpen: false })  }} />
            <Loading isOpen={isLoading} />
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
                <div className="w-full max-w-3xl px-6 py-10">
                    <div className="absolute top-4 left-4">
                        <button className="flex items-center justify-center p-2 bg-white rounded-full shadow-sm border border-neutral-100 hover:bg-neutral-50 transition-all transform hover:scale-105 active:scale-95"
                            onClick={() => navigate('/cart')}
                        >
                            <span className="material-symbols-outlined text-neutral-700">arrow_back</span>
                        </button>
                    </div>
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">payments</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Confirmación de Pago</h1>
                        <p className="text-neutral-600 text-center">
                            Revise los detalles de su pedido antes de realizar el pago
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        <div className="border-b border-neutral-100 pb-4 mb-4">
                            <h2 className="text-lg font-semibold text-neutral-900 mb-4">Resumen del Pedido</h2>
                            <div className="space-y-3">
                                {/*<div className="flex justify-between items-center">
                                    <p className="text-neutral-600">Subtotal</p>
                                    <p className="font-medium text-neutral-900">€42,90</p>
                                </div>
                                <div className="flex justify-between items-center">
                                    <p className="text-neutral-600">Gastos de envío</p>
                                    <p className="font-medium text-neutral-900">€3,99</p>
                                </div>
                                <div className="flex justify-between items-center">
                                    <p className="text-neutral-600">Impuestos (21% IVA)</p>
                                    <p className="font-medium text-neutral-900">€9,01</p>
                                </div>*/}
                                <div className="flex justify-between items-center pt-2 border-t border-neutral-100">
                                    <p className="font-semibold text-neutral-900">Total</p>
                                    <p className="text-xl font-bold text-primary-600">${toPesos(total)}</p>
                                </div>
                            </div>
                        </div>

                        <div className="border-b border-neutral-100 pb-4 mb-4">
                            <h2 className="text-lg font-semibold text-neutral-900 mb-4">{currentOrder?.tipo=='delivery'?'Dirección de entrega':'Recoger en tienda'}</h2>
                            <div className="bg-neutral-50 rounded-xl p-4 border border-neutral-100 hover:border-primary-200 transition-all">
                                <div className="flex items-start space-x-3">
                                    <span className="material-symbols-outlined text-primary-600 mt-0.5">
                                        {currentOrder?.tipo=='delivery'?'location_on':'fastfood'}
                                    </span>
                                    {currentOrder?.tipo=='delivery'?(
                                        <div>
                                            <p className="text-neutral-600">{currentOrder?.xtra_data?.calle} {currentOrder?.xtra_data?.ext} {currentOrder?.xtra_data?.int}</p>
                                            <p className="text-neutral-600">{currentOrder?.xtra_data?.colonia}, {currentOrder?.xtra_data?.delegacion}</p>
                                            <p className="text-neutral-600">{currentOrder?.xtra_data?.estado} {currentOrder?.xtra_data?.cp}</p>
                                            
                                        </div>
                                     ):(
                                        <>
                                        <p className="text-neutral-800">{currentOrder?.xtra_data?.nombre}</p>
                                        <p className="text-neutral-600">{nl2br(currentOrder?.xtra_data?.direccion)}</p>
                                        
                                        </>
                                        
                                     )}
                                    
                                </div>
                                <button className="mt-2 text-sm text-primary-600 flex items-center hover:text-primary-700 transition-colors"
                                                onClick={() => navigate('/tipoSelect')}
                                            >
                                                <span className="material-symbols-outlined text-sm mr-1">edit</span>
                                                Seleccionar otra {currentOrder?.tipo=='delivery'?'dirección':'sucursal'}
                                            </button>
                            </div>
                        </div>

                        <div className="mb-6">
                            <h2 className="text-lg font-semibold text-neutral-900 mb-4">Método de Pago</h2>
                            <div className="space-y-3">

                                {pInfo && pInfo.includes('app') && (
                                    <label className={cn("flex items-center p-4 rounded-xl border  cursor-pointer transition-all hover:bg-primary-50/50", {
                                        "border-primary-200 bg-primary-50/30": checkedPayment === 'app',
                                        "border-transparent": checkedPayment !== 'app',
                                    })}>
                                        <input
                                            type="radio"
                                            name="payment"
                                            className="form-radio h-4 w-4 text-primary-600 focus:ring-primary-500"
                                            checked={checkedPayment==='app'}
                                            onChange={()=>setCheckedPayment('app')}
                                        />
                                        <div className="ml-3">
                                            <p className="font-medium text-neutral-900">Pagar ahora</p>
                                            <p className="text-xs text-neutral-500">
                                                Pague con tarjeta, Apple Pay, Google Pay.
                                            </p>
                                        </div>
                                    </label>
                                )}
                                {currentOrder?.tipo=='out' && pInfo && pInfo.includes('sucursal') && (
                                    <label className={cn("flex items-center p-4 rounded-xl border border-primary-200 bg-primary-50/30 cursor-pointer transition-all hover:bg-primary-50/50", {
                                        "border-primary-200 bg-primary-50/30": checkedPayment === 'sucursal',
                                        "border-transparent": checkedPayment !== 'sucursal',
                                    })}>
                                        <input
                                            type="radio"
                                            name="payment"
                                            className="form-radio h-4 w-4 text-primary-600 focus:ring-primary-500"
                                            checked={checkedPayment==='sucursal'}
                                            onChange={()=>setCheckedPayment('sucursal')}
                                        />
                                        <div className="ml-3">
                                            <p className="font-medium text-neutral-900">Pagar en sucursal</p>
                                            <p className="text-xs text-neutral-500">
                                                Pague con tarjeta o efectivo en la sucursal
                                            </p>
                                        </div>
                                    </label>
                                )}
                                {currentOrder?.tipo=='delivery' && pInfo && pInfo.includes('delivery_card') && (
                                    <label className={cn("flex items-center p-4 rounded-xl border border-primary-200 bg-primary-50/30 cursor-pointer transition-all hover:bg-primary-50/50", {
                                        "border-primary-200 bg-primary-50/30": checkedPayment === 'delivery_card',
                                        "border-transparent": checkedPayment !== 'delivery_card',
                                    })}>
                                        <input
                                            type="radio"
                                            name="payment"
                                            className="form-radio h-4 w-4 text-primary-600 focus:ring-primary-500"
                                            checked={checkedPayment==='delivery_card'}
                                            onChange={()=>setCheckedPayment('delivery_card')}
                                        />
                                        <div className="ml-3">
                                            <p className="font-medium text-neutral-900">Pagar con tarjeta al recibir</p>
                                            <p className="text-xs text-neutral-500">
                                                El repartidor llevará una terminal para procesar su pago.
                                            </p>
                                        </div>
                                    </label>
                                )}
                                {currentOrder?.tipo=='delivery' && pInfo && pInfo.includes('delivery_cash') && (
                                    <label className={cn("flex items-center p-4 rounded-xl border border-primary-200 bg-primary-50/30 cursor-pointer transition-all hover:bg-primary-50/50", {
                                        "border-primary-200 bg-primary-50/30": checkedPayment === 'delivery_cash',
                                        "border-transparent": checkedPayment !== 'delivery_cash',
                                    })}>
                                        <input
                                            type="radio"
                                            name="payment"
                                            className="form-radio h-4 w-4 text-primary-600 focus:ring-primary-500"
                                            checked={checkedPayment==='delivery_cash'}
                                            onChange={()=>setCheckedPayment('delivery_cash')}
                                        />
                                        <div className="ml-3">
                                            <p className="font-medium text-neutral-900">Pagar con efectivo al recibir</p>
                                            <p className="text-xs text-neutral-500">
                                                Favor de pagar con cambio exacto.
                                            </p>
                                        </div>
                                    </label>
                                )}
                                

                               
                            </div>
                        </div>

                        <div className="flex justify-center pt-4">
                            <button className="w-full flex items-center justify-center px-6 py-3 bg-primary-600 text-white rounded-xl hover:bg-primary-700 transition-all shadow-sm transform hover:translate-y-[-2px] active:translate-y-[0px] disabled:bg-neutral-300 disabled:cursor-not-allowed"
                                disabled={!checkedPayment}
                                onClick={handleCheckout}
                            >
                                <span className="material-symbols-outlined text-sm mr-2">lock</span>
                                {(checkedPayment==='sucursal' || checkedPayment === 'delivery_cash' || checkedPayment === 'delivery_card') ? 'Pagar al recibir ' : 'Pagar ahora '}
                                ${}{toPesos(total)}
                            </button>
                        </div>
                    </div>

                    <div className="flex justify-center space-x-4">
                        <button className="flex items-center justify-center px-4 py-2 bg-white border border-neutral-200 text-neutral-800 rounded-xl hover:bg-neutral-50 transition-all shadow-sm"
                            onClick={() => navigate('/cart')}
                        >
                            <span className="material-symbols-outlined text-sm mr-1">arrow_back</span>
                            Volver
                        </button>
                       {/* <button className="flex items-center justify-center px-4 py-2 bg-white border border-neutral-200 text-neutral-800 rounded-xl hover:bg-neutral-50 transition-all shadow-sm">
                            <span className="material-symbols-outlined text-sm mr-1">help_outline</span>
                            Ayuda
                        </button>*/}
                    </div>
                </div>
            </div>
        </div>);
}

export default Checkout;